import {
  integrationSyncFailedItemDtoSchema,
  syncFailedItemsPageResponseSchema,
} from '@tempo-io/work-integration-dto';
import type { z } from 'zod';
import { tempoApi } from '@/common/api/tempoApi';

export const SyncFailureType = integrationSyncFailedItemDtoSchema.shape.type.enum;

export type SyncFailureType = (typeof SyncFailureType)[keyof typeof SyncFailureType];

export type IntegrationSyncFailedItem = z.infer<typeof integrationSyncFailedItemDtoSchema>;

export type SyncFailedItemsPageResponse = z.infer<typeof syncFailedItemsPageResponseSchema>;

const getSyncFailedItemsForIntegration = async ({
  integrationId,
  page,
  pageSize,
}: {
  integrationId: number;
  page?: number;
  pageSize?: number;
}): Promise<SyncFailedItemsPageResponse> => {
  const searchParams: Record<string, string> = {};
  if (page !== undefined) searchParams.page = String(page);
  if (pageSize !== undefined) searchParams.pageSize = String(pageSize);
  const response = await tempoApi()
    .get(`api/v1/work-integrations/sync-failures/integrations/${integrationId}`, {
      searchParams,
    })
    .json();
  return syncFailedItemsPageResponseSchema.parse(response);
};

const getSyncFailedItemsByItem = async ({
  itemIdOrSourceItemKey,
  page,
  pageSize,
}: {
  itemIdOrSourceItemKey: string;
  page?: number;
  pageSize?: number;
}): Promise<SyncFailedItemsPageResponse> => {
  const searchParams: Record<string, string> = {};
  if (page !== undefined) searchParams.page = String(page);
  if (pageSize !== undefined) searchParams.pageSize = String(pageSize);
  const response = await tempoApi()
    .get(`api/v1/work-integrations/sync-failures/items/${itemIdOrSourceItemKey}`, {
      searchParams,
    })
    .json();
  return syncFailedItemsPageResponseSchema.parse(response);
};

export const SyncFailuresApi = {
  getSyncFailedItemsForIntegration,
  getSyncFailedItemsByItem,
};
